module.exports = __webpack_public_path__ + "img/icons.962a1bf3.448f2aaa.svg";